<template>
  <span>
    <div>
      <MDinput
        v-model="order.finishedHeightInCm"
        type="number"
        :required="false"
        :maxlength="16"
        :precision="1"
        name="orderLine.height"
        @input="emitValues"
      >
        {{ $t('orderLine.height') }}
      </MDinput>
    </div>
  </span>
</template>

<script>
import MDinput from '@/components/MDinput';

export default {
  name: 'GenericOrderComponents',
  components: { MDinput },
  props: {
    domainID: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      order: {},
      recVal: null
    };
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    emitValues() {
      this.$emit('input', this.order);
    }
  }
};
</script>
<style lang="scss"></style>
